<template>
  <router-view></router-view>
</template>

<script>
import { computed, onUnmounted } from "vue";
import { useStore } from "vuex";
import { Decrypt, Encrypt } from "@/store/modules/aes";
import { getRSAPublicKey, rsaDecrypt } from "@/store/modules/rsa";
export default {
  name: "App",
  setup() {
    const store = useStore();

    //getters
    const sideBar = computed(() => store.getters["sideBarTree/get_sideBar"]);
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      change_loginData: (payload) => {
        store.dispatch("getLogin/change_loginData", payload);
      },
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      set_sideBar: (payload) => {
        store.dispatch("sideBarTree/set_sideBar", payload);
      },
    };

    //function
    //抓取使用者權限
    const checkAccessList = (uID) => {
      var params = {};
      params["methods"] = "GET";
      params["whichFunction"] = "Login";
      if (uID.length == 0) {
        return;
      }

      params["RSAPublicKey"] = getRSAPublicKey();
      params["uID"] = uID;
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;
        if (result["Response"] != "ok") {
          return;
        }
        if (result["QueryTableData"].length < 1) {
          return;
        }
        var obj = {};
        obj.account = result["QueryTableData"][0].user_id;
        let key = JSON.parse(rsaDecrypt(result["QueryTableData"][0].key));
        obj.status = true;
        obj.username = Decrypt(
          result["QueryTableData"][0].name,
          key.key,
          key.iv
        );
        methods.set_sideBar(
          JSON.parse(
            Decrypt(result["QueryTableData"][0].access_list, key.key, key.iv)
          )
        );

        methods.change_loginData(obj);
      });
    };

    if (sessionStorage.getItem("loginStatus") != null) {
      let obj = {};
      obj.account = sessionStorage.getItem("loginAccount");
      obj.status = Boolean(sessionStorage.getItem("loginStatus"));
      obj.username = sessionStorage.getItem("loginUsername");
      if (sessionStorage.getItem("loginSideBar")) {
        if (Decrypt(sessionStorage.getItem("loginSideBar")) != "undefined") {
          obj.sideBar = JSON.parse(
            Decrypt(sessionStorage.getItem("loginSideBar"))
          );
        } else {
          obj.sideBar = {};
        }
      }
      console.log(sideBar);
      if (obj.status == true) {
        methods.change_loginData(obj);
        methods.set_sideBar(obj.sideBar);
        sessionStorage.removeItem("loginStatus");
        sessionStorage.removeItem("loginUsername");
        sessionStorage.removeItem("loginAccount");
        sessionStorage.removeItem("loginSideBar");
        //若為登入狀態，則更新使用者權限
        checkAccessList(obj.account);
      }
    }

    const setSessionItems = () => {
      if (loginData.value.status === true) {
        sessionStorage.setItem("loginStatus", loginData.value.status);
        sessionStorage.setItem("loginUsername", loginData.value.username);
        sessionStorage.setItem("loginAccount", loginData.value.account);
        sessionStorage.setItem(
          "loginSideBar",
          Encrypt(JSON.stringify(sideBar.value))
        );
        //   // window.location.replace("https://192.168.39.73:8885/KingMaker");
      }
    };
    window.addEventListener("beforeunload", () => {
      setSessionItems();
    });

    onUnmounted(() => {
      window.removeEventListener("beforeunload", setSessionItems);
    });
  },
  components: {},
};
</script>

<style>
@font-face {
  font-family: "dfyuanstd-w3";
  src: url("assets/css/dfyuanstd-w3.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "dfyuanstd-w5";
  src: url("assets/css/dfyuanstd-w5.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "dfyuanstd-w7";
  src: url("assets/css/dfyuanstd-w7.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "dfyuanstd-w8";
  src: url("assets/css/dfyuanstd-w8.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
}
#app {
  font-family: "dfyuanstd-w7";
  outline: none; /* 去除點擊的藍邊框 */
  min-width: 320px;
}
</style>
